export const PARTNERS = {
  BRANDNAMIC: 'BRANDNAMIC',
};
